import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import storageService from "../../Services/storageService";
import { useEffect } from "react";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
const Footer = ({ isHotel = true, slug = "", id = "", name = "" }) => {
  const [languageSelected, setlanguageSelected] = useState("en");

  const location = useLocation();
  const history = useHistory();

  const [isBookMyStay] = useState(
    [
      "www.bookmystay.io",
      "bookmystay.io",
      "dev.hotelzify.com",
      "hotelzify.com",
      "www.hotelzify.com",
    ].includes(window.location.host)
  );

  const [isSlug] = useState(
    [
      "dev.hotelzify.com",
      "hotelzify.com",
      "www.hotelzify.com",
      "localhost:3005",
    ].includes(window.location.host)
  );

  const { t } = useTranslation();

  useEffect(() => {
    let ln = storageService.get("lang") || "en";
    setlanguageSelected(ln);
  }, []);

  const changeLanguage = (e) => {
    let ln = e.target.value;
    fireGtmEvent("language_changed", { languageSelected: ln });
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("language", ln);

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
    setlanguageSelected(ln);
    storageService.set("lang", ln);
    i18n.changeLanguage(ln);
    window?.location?.reload();
  };

  return (
    <div className="footer" id="footer">
      <div className="footerTexts">
        {!isHotel && (
          <p>
            <Link
              style={{ textDecoration: "none", color: "var(--text-gray)" }}
              to={"/privacy-policy"}
            >
              {t("privacy_policy")}
            </Link>
          </p>
        )}
        {!isHotel && (
          <p>
            <Link
              style={{ textDecoration: "none", color: "var(--text-gray)" }}
              to={"/terms-conditions"}
            >
              {t("terms_and_conditions")}
            </Link>
          </p>
        )}

        {isHotel && (
          <label
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <p>{t("change_language")}</p>
            <select
              name="language"
              style={{
                border: "none",
                background: "transparent",
                outline: "none",
              }}
              value={languageSelected}
              onChange={changeLanguage}
            >
              <option value="en">English</option>
              <option value="hi">Hindi</option>
              <option value="de">German</option>
              <option value="ar">Arabic</option>
            </select>
          </label>
        )}

        {isHotel && (
          <p>
            <Link
              style={{ textDecoration: "none", color: "var(--text-gray)" }}
              to={{
                pathname: isSlug
                  ? `/${slug}/privacy-policy`
                  : "/privacy-policy",
                state: {
                  slug,
                },
              }}
            >
              {t("privacy_policy")}
            </Link>
          </p>
        )}

        {isHotel && (
          <p>
            <Link
              style={{ textDecoration: "none", color: "var(--text-gray)" }}
              to={{
                pathname: isSlug
                  ? `/${slug}/terms-conditions`
                  : "/terms-conditions",
                state: {
                  slug,
                },
              }}
            >
              {t("terms_and_conditions")}
            </Link>
          </p>
        )}

        <p style={{ display: "flex", gap: "5px" }}>
          {t("powered_by")}{" "}
          <a href="https://hotelzify.com" target={"_blank"}>
            {" "}
            Hotelzify
          </a>
        </p>
        <p>{t("made_with_love_in_india")}</p>
      </div>

      <div className="footerAddress" style={{ color: "#000" }}>
        <p style={{ textTransform: "uppercase" }}>
          {t("copyrights")} © {name.split("|")[0] || name}.{" "}
          {t("all_rights_reserved")}
        </p>
      </div>

      {!isHotel && (
        <div className="footerAddress">
          <p>
            {t("please_reach_us_at")}{" "}
            <a href="tel:+917975660291">79756 60291</a>
          </p>
          <p>S4-101, Greenwood Regency, Bengaluru, Karnataka 560035</p>
        </div>
      )}
    </div>
  );
};

export default Footer;
